export default "__VITE_ASSET__eIQzW0ZD__"